import * as fromDatatype from '../datatype-library';

export interface bl_fi_xtn_generic_doc_hdr_driver_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid:fromDatatype.GuidDataFieldInterface;
    xtn_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    vehicle_no:fromDatatype.VarcharDatatypeInterface;
    expected_delivery:fromDatatype.TimestampTzDatatypeInterface;
    actual_delivery:fromDatatype.TimestampTzDatatypeInterface;
    planned_delivery:fromDatatype.TimestampTzDatatypeInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;

}

export class bl_fi_xtn_generic_doc_hdr_driver_link_RowClass
  implements bl_fi_xtn_generic_doc_hdr_driver_link_RowInterface 
  {
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid:fromDatatype.GuidDataFieldInterface;
    xtn_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    vehicle_no:fromDatatype.VarcharDatatypeInterface;
    expected_delivery:fromDatatype.TimestampTzDatatypeInterface;
    actual_delivery:fromDatatype.TimestampTzDatatypeInterface;
    planned_delivery:fromDatatype.TimestampTzDatatypeInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;

  }